<app-user-message *ngIf="loadError" type="error" title="Unable to load your household" message="Check your connection and try again, or verify your phone number." [dismissible]="false"><div messageActions class="user-message-actions"><button type="button" class="btn btn-primary" (click)="ngOnInit()">Try again</button><button type="button" class="btn btn-outline-secondary" (click)="resetHousehold()">Verify phone</button></div></app-user-message>
<div class="container checkin-page">
    <div class="row justify-content-center align-items-start">
<div *ngIf="isLoading == true" class="col-12 d-flex justify-content-center align-items-center full-height">
  <app-loading-spinner></app-loading-spinner>
</div>
        <div class="card SmallForm rounded col-11"
            *ngIf="isLoading == false && !loadError && (isIdentity == false || userId == null)">
            <div class="card-body MyCardBody rounded-bottom">
                <div class="form-group row">
                    <div class="col-12" *ngIf="userId == null">
                        <ng-container *ngIf="emailVerification"><p>Verify your email once. We’ll remember this device for quick check-in.</p><button type="button" class="btn btn-primary btn-block" (click)="emailAccess()">Continue by email</button><a [routerLink]="['/', tenantId, 'login']">Sign in with password</a></ng-container><div *ngIf="!emailVerification">Please enter your cell phone number</div>
                        <br>
                        <app-phone-verify *ngIf="!emailVerification" [dial_code]="dial_code" [userExists]="true" [enabled]="true" [portrait]="true"
                            [phone_number]=" " (failed)="failedVerification()" (clearEvent)="clearCellPhone()"
                            (confirmNumber)="ConfirmCellPhone($event)"></app-phone-verify>
                    </div>
                    <div class="form-group col-12" *ngIf="userId != null && members.length > 0">
                        <div class="row" *ngIf="members.length > 0">
                            <div class="form-group col-11 m-auto text-center">
                                <p class="mb-3 font-weight-bold">Select the attendees, then tap Check-In.</p>
                                <div *ngIf="QRCode != ''">
                                    <img *ngIf="qrImage" [src]="qrImage" width="192" />
                                </div>
                                <div *ngFor="let member of members">
                                    <div class="row my-2">

                                        <button class="btn btn-block memberButton" (click)="toggleMember(member)"
                                            [ngClass]="{
                                 'btn-success': 
                                  member['checked'] == true,
                                'btn-light':                                  
                                  member['checked'] == false
                              }" type="button">
                                            <span>
                                                <app-checkin-avatar [member]="member"></app-checkin-avatar> {{ member.firstName }} {{ member.lastName }}
                                                <i class="fas mt-1" style="float: right"
                                                    [class.fa-check-square]="member['checked'] == true"
                                                    [class.fa-square]="
                                    member['checked'] == false
                                  "></i>
                                            </span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="userId != null && members.length > 0" class="col-12">
                        <p class="checkin-consent">
                            By checking in, you agree to the Church Services
                            <a href="https://church-services.com/terms-of-use/" target="_blank" rel="noopener noreferrer">Terms of Use</a>.
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-10">
            <div class="row" *ngIf="isLoading ==false && (isIdentity == true && userId != null)">
                <app-prompt-message style="width:100%" [showForm]="true" color="success" (onClose)="goHome()"
                    message="Your identity has been successfully verified.">
                </app-prompt-message>
                <button class="btn btn-secondary btn-block" type="button" (click)="goHome()">
                    <span [class.ArabicFont]="globalService.isRTL == true">
                        Close
                    </span>
                </button>
            </div>
        </div>
    </div>
</div>